import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from 'components/ui-components/Button';
import TextInput from 'components/ui-components/TextInput';
import Card from 'components/ui-components/Card';
import { useHTTP } from 'hooks/useRequest';
import responsive from 'utils/responsive';
import { gaMFADisabled } from 'data_layer/ga_authentication_events';

const MFAOptOutForm = ({ myCefUrl }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [validateErrors, setValidateErrors] = useState(false);
  const [hasBeenSubmitted, setHasBeenSubmitted] = useState(false);

  const mfaOptOutRequestConfig = {
    method: 'POST',
    url: hasBeenSubmitted ? '/mfa/confirm_disable' : null,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      password,
    }),
  };

  const {
    data: mfaOptOutResponse,
    error: mfaOptOutError,
    loading,
  } = useHTTP(mfaOptOutRequestConfig || null);

  const validatePassword = s => {
    const isValid = s.length > 0;
    setError(
      !isValid
        ? {
            password: {
              message: 'Please enter your password',
            },
          }
        : null,
    );
    return isValid;
  };

  const handleChange = e => {
    setPassword(e.target.value);
  };

  const handleSubmit = e => {
    e.preventDefault();
    setValidateErrors(true);
    const success = validatePassword(password);

    if (success) {
      setHasBeenSubmitted(true);
    }
  };

  useEffect(() => {
    setHasBeenSubmitted(false);

    const errors = mfaOptOutError?.error?.data?.errors ?? [];

    if (mfaOptOutResponse?.success) {
      gaMFADisabled();
      window.location.href = mfaOptOutResponse?.url;
    } else if (errors.length && errors.includes('invalid_password')) {
      setError({
        password: {
          message: 'Your password is incorrect. Please try again.',
        },
      });
    }
  }, [mfaOptOutResponse, mfaOptOutError]);

  useEffect(() => {
    if (validateErrors) {
      validatePassword(password);
    }
  }, [password, validateErrors]);

  return (
    <FormWrapper className="margin-center width-100">
      <h1 className="ff-body fw-600 fs-30 l-fs-36 lh-1-2 l-lh-1 tc-main ta-c mb-12 mt-52">
        Turn Off Two-Factor Authentication
      </h1>
      <p className="fs-18 lh-1-25 tc-secondary ta-c m-fb-60 pb-28">
        After turning off two-factor authentication, a verification code will no
        longer be required to sign in to your account.
      </p>
      <form onSubmit={handleSubmit}>
        <Card variant="large" className="mb-32">
          <div className="mb-24">
            <TextInput
              variant="feature"
              type="password"
              id="password"
              value={password}
              onChange={handleChange}
              required
              label="Password"
              description="Please enter your password to confirm this change"
              errors={error}
              className="mb-45"
            />
          </div>

          <div className="actions fl sm-fl-col m-fl-row-reverse jc-sb ai-c">
            <SubmitButton
              type="submit"
              className="cef-btn cef-btn--green cef-btn--feature m-ml-24 width-100">
              {loading ? (
                <span className="cef-btn__loader bs-bb" />
              ) : (
                'Turn Off'
              )}
            </SubmitButton>

            <Button
              className="fl ai-c td-u fs-18 tc-grey-60 cef-btn--high cef-btn--as-link mt-24 m-mt-0"
              handleClick={() => {
                window.location.href = myCefUrl;
              }}>
              Cancel
            </Button>
          </div>
        </Card>
      </form>
    </FormWrapper>
  );
};

const FormWrapper = styled.div`
  ${responsive('desktopSmall')} {
    max-width: 650px;
  }
`;

const SubmitButton = styled(Button)`
  max-width: 250px;
`;

export default MFAOptOutForm;
